import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { MainService } from 'src/app/services/main.service';
import { ProjectsService } from 'src/app/services/projects.service';
import { UsersService } from 'src/app/services/users.service';
import Swal from 'sweetalert2';
import { ProjectsVoboAlertsConfigComponent } from '../projects-vobo-alerts-config/projects-vobo-alerts-config.component';

@Component({
  selector: 'app-projects-vobo-add',
  templateUrl: './projects-vobo-add.component.html',
  styleUrls: ['./projects-vobo-add.component.scss']
})
export class ProjectsVoboAddComponent implements OnInit {
  newVobo!: any;
  id_proj : number = 0;
  isEdit : boolean = false;
  usersList : any[] = [];
  formsList : any[] = [];
  itemToAdd : string = "";
  allvobos : any[] = [];


  userSearchTerm: string = '';
  filteredUsers: any[] = [];
  formSearchTerm: string = '';
  filteredForms: any[] = [];
  hasProveedor : boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data : any,
    private main: MainService,
    private projectS: ProjectsService,
    private userS: UsersService,
    private matDialog: MatDialog,
    private dialogRef: MatDialogRef<ProjectsVoboAddComponent>,
  ) { 
    this.newVobo = this.data.vobo;
    this.usersList = this.data.users;
    this.formsList = this.data.forms;
    this.filteredUsers = this.usersList.slice();
    this.filteredForms = this.formsList.slice();
    this.hasProveedor = this.data.hasProveedor;
    this.allvobos = this.data.lista;

    if (!this.newVobo.alerts_config) {
      this.newVobo.alerts_config = [];
    }

    this.isEdit = this.data.vobo.id != 0;
    this.prevStatusData = JSON.stringify(this.data);
    console.log(this.newVobo);

  }

  prevStatusData : any;

  ngOnInit(): void { 
    if(!this.isEdit) {
     
    }

    this.dialogRef.backdropClick().subscribe(() => {
      this.cancelcloseForm();
    });

    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === "Escape") this.cancelcloseForm();
    });
  }

  setUsers(t: any) {
    this.newVobo.users = t;
  }

  setVobos(t: any) {
    this.newVobo.vobos = t;
  }

  isDupledNewVobo(){
   let isDupled = this.formsList.some(item => item.nombre.trim().toLowerCase() === this.itemToAdd.trim().toLowerCase());
    if(isDupled){
      Swal.fire({
        icon: 'error',
        title: 'Formulario Duplicado',  
        text: 'El formulario se encuentra duplicado.'
      });
    }

    return isDupled;
  }

  loadFormularios(){
    this.projectS.getFormularios().subscribe((x:any)=>{
      this.formsList = x.data;
    });
 }

 cancelcloseForm(){
  if(this.isEdit){
     let oldData = JSON.parse(this.prevStatusData)
     this.dialogRef.close(oldData);
  }else{
    this.dialogRef.close();
  }

 }

 closeForm() {
    const mensajes = [];

    if (!this.newVobo.area || this.newVobo.area.trim() === "") {
      mensajes.push("El nombre del área es obligatorio.");
    }
    if (!this.newVobo.vobos || this.newVobo.vobos.length === 0) {
      mensajes.push("Seleccione al menos un campo de formulario.");
    }
    if (!this.newVobo.optional && (!this.newVobo.users || this.newVobo.users.length === 0)) {
      mensajes.push("Seleccione al menos un usuario.");
    }
    if (!this.newVobo.scheluded_time_days || this.newVobo.scheluded_time_days <= 0) {
      mensajes.push("Los días programados son obligatorios y deben ser mayores a 0.");
    }

    // --- INICIO: Nueva validación de días programados ---
    if (this.allvobos && this.allvobos.length > 0) {
      // En modo edición, el vobo actual ya está en la lista. En modo creación, no.
      const currentIndex = this.isEdit ? this.allvobos.findIndex((item: any) => item.order_id === this.newVobo.order_id) : this.allvobos.length;

      // Validar con el VoBo anterior
      if (currentIndex > 0) {
        const previousVobo = this.allvobos[currentIndex - 1];
        if (this.newVobo.scheluded_time_days < previousVobo.scheluded_time_days) {
          mensajes.push(`Los días programados no pueden ser menores que los del VoBo anterior (${previousVobo.scheluded_time_days} días).`);
        }
      }

      // Validar con el VoBo siguiente (solo en modo edición y si no es el último)
      if (this.isEdit && currentIndex < this.allvobos.length - 1) {
        const nextVobo = this.allvobos[currentIndex + 1];
        if (this.newVobo.scheluded_time_days > nextVobo.scheluded_time_days) {
          mensajes.push(`Los días programados no pueden ser mayores que los del VoBo siguiente (${nextVobo.scheluded_time_days} días).`);
        }
      }
    }
    // --- FIN: Nueva validación ---

    if (mensajes.length > 0) {
      Swal.fire({
        icon: 'warning',
        title: 'Campos inválidos o faltantes',
        html: mensajes.join("<br>")
      });
      return;
    }

    // Si todas las validaciones pasan
    console.log(this.newVobo);
    this.dialogRef.close(this.data);
  }

  saveFormulario(){
    if(!this.isDupledNewVobo() && this.itemToAdd != ""){
      this.projectS.createFormulario({nombre : this.itemToAdd}).subscribe(
        (result:any) => {
          if(result.message == "Success") {
            let select_id = result.data;
            this.newVobo.vobos.push(select_id);
            Swal.fire({
              icon: 'success',
              title: 'Guardado',
              text: 'Formulario guardado correctamente'          
            }).then(() => {  
              this.itemToAdd = "";
              console.log("result vobo", result)          
              this.loadFormularios();
            });
          }
        },
        (err:any) => {
            console.log(err);
            Swal.fire({
              icon: 'error',
              title: 'Error al guardar',
              text: 'Ocurrió un error al guardar el registro, por favor vuelve a intentarlo.'
            });
          }       
      );
    }
  }

  filterUsers(): void {
    const searchTerm = this.userSearchTerm.toLowerCase();
    let sourceList = this.usersList;

    if (searchTerm) {
      sourceList = this.usersList.filter(user =>
        user.name.toLowerCase().includes(searchTerm)
      );
    }

    const selectedUserIds = this.newVobo.users || [];
    this.filteredUsers = sourceList.slice().sort((a, b) => {
      const aSelected = selectedUserIds.includes(a.id);
      const bSelected = selectedUserIds.includes(b.id);
      if (aSelected && !bSelected) return -1;
      if (!aSelected && bSelected) return 1;
      return 0;
    });

  }

  clearUserSearch(): void {
    this.userSearchTerm = '';
    this.filterUsers();
  }

  toggleAllUsers(): void {
    const filteredIds = this.filteredUsers.map(u => u.id);
    if (this.areAllUsersSelected()) {
      //todos los visibles quitar
      this.newVobo.users = this.newVobo.users.filter((id: number) => !filteredIds.includes(id));
    } else {
      //todos los visibles seleccionar
      const newSelection = [...new Set([...this.newVobo.users, ...filteredIds])];
      this.newVobo.users = newSelection;
    }
  }

  areAllUsersSelected(): boolean {
    if (this.filteredUsers.length === 0) return false;
    const filteredIds = this.filteredUsers.map(u => u.id);
    const selectedIds = this.newVobo.users || [];
    return filteredIds.every(id => selectedIds.includes(id));
  }

  filterForms(): void {
    const searchTerm = this.formSearchTerm.toLowerCase();
    let sourceList = this.formsList;

    if (searchTerm) {
      sourceList = this.formsList.filter(form =>
        form.nombre.toLowerCase().includes(searchTerm)
      );
    }

    const selectedFormIds = this.newVobo.vobos || [];
    this.filteredForms = sourceList.slice().sort((a, b) => {
      const aSelected = selectedFormIds.includes(a.id);
      const bSelected = selectedFormIds.includes(b.id);
      if (aSelected && !bSelected) return -1;
      if (!aSelected && bSelected) return 1;
      return 0;
    });
  }

  clearFormSearch(): void {
    this.formSearchTerm = '';
    this.filterForms();
  }

  toggleAllForms(): void {
    const filteredIds = this.filteredForms.map(f => f.id);
    if (this.areAllFormsSelected()) {
      // quitar todos los visibles
      this.newVobo.vobos = this.newVobo.vobos.filter((id: number) => !filteredIds.includes(id));
    } else {
      // seleccionar todos los visibles
      const newSelection = [...new Set([...this.newVobo.vobos, ...filteredIds])];
      this.newVobo.vobos = newSelection;
    }
  }

  areAllFormsSelected(): boolean {
    if (this.filteredForms.length === 0) return false;
    const filteredIds = this.filteredForms.map(f => f.id);
    const selectedIds = this.newVobo.vobos || [];
    return filteredIds.every(id => selectedIds.includes(id));
  }

  openAlertsConfig(): void {
    const selectedVobosInfo = this.formsList.filter(form => this.newVobo.vobos.includes(form.id))
      .map(form => ({ id: form.id, nombre: form.nombre }));

    const dialogRef = this.matDialog.open(ProjectsVoboAlertsConfigComponent, {
      width: '1000px',
      data: {
        selectedVobos: selectedVobosInfo,
        alertsConfig: this.newVobo.alerts_config
      }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.newVobo.alerts_config = result;
      }
    });
  }

  get configuredAlertsCount(): number {
    if (!this.newVobo.alerts_config || !this.newVobo.vobos) {
      return 0;
    }
    // Contamos solo las alertas configuradas para los vobos actualmente seleccionados.
    const selectedVoboIds = new Set(this.newVobo.vobos);
    return this.newVobo.alerts_config.filter((alert: any) => selectedVoboIds.has(alert.id)).length;
  }

  get totalSelectedVobos(): number {
    return this.newVobo.vobos?.length || 0;
  }
}
